export interface Option {
  label: string;
  value: string;
}

interface FilterTabsProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
}

export function FilterTabs({ options, value, onChange }: FilterTabsProps) {
  return (
    <div className="border-line bg-background flex w-fit gap-1 rounded-md border p-1">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          className={`rounded-sm px-5 py-1.5 text-sm transition-colors ${
            value === opt.value
              ? 'bg-surface text-primary font-semibold shadow-sm'
              : 'text-on-surface-light hover:text-on-surface font-medium'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
